@if (loading()) {
  <nk-progress></nk-progress>
}
@if (collateralComposite$ | async; as collateralComposite) {
  <table class="table table-striped small" [class.report-table-padded]="printVersion()">
    <thead>
      @if (showForCorporateGroup()) {
        <th>{{ 'company_collateral.company_name' | translate }}</th>
      }
      <th>{{ 'company_collateral.date' | translate }}</th>
      <th>{{ 'company_collateral.type' | translate }}</th>
      <th>{{ 'company_collateral.items' | translate }}</th>
      <th>{{ 'company_collateral.creditor' | translate }}</th>
      <th class="text-end">{{ 'company_collateral.amount' | translate }} NOK</th>
    </thead>
    <tbody [class.faded-3]="loading()">
      @if (collateralComposite.elements.length === 0) {
        <tr>
          <td colspan="6">
            {{ 'company_collateral.no_data' | translate }}
          </td>
        </tr>
      }
      @for (comp of collateralComposite.elements; track comp.company_collateral.uuid) {
        <tr>
          @if (showForCorporateGroup()) {
            <td class="small">
              @if (comp.company.uuid !== companyUuid()) {
                <a [routerLink]="['/company', comp.company.uuid]">
                  <nk-company-title [company]="comp.company" [showOrgNr]="false"></nk-company-title>
                </a>
              } @else {
                <nk-company-title [company]="comp.company" [showOrgNr]="false"></nk-company-title>
              }
            </td>
          }
          <td class="small text-nowrap">
            <span [tooltip]="comp.company_collateral.registered_date | date">{{
              comp.company_collateral.registered_date | date
            }}</span>
            @if (comp.company_collateral.deletion_flag && !comp.company_collateral.deletion_date) {
              <div>- {{ 'company_collateral.deletion_date_unknown' | translate }}</div>
            }
            @if (comp.company_collateral.deletion_date) {
              <div [tooltip]="'company_collateral.deletion_date_tooltip' | translate">
                -
                <span [tooltip]="comp.company_collateral.registered_date | date">
                  {{ comp.company_collateral.deletion_date | date }}</span
                >
              </div>
            }
          </td>

          <td class="small">
            {{ 'collateral_type_key.' + comp.company_collateral_type.collateral_type_key | translate }}
          </td>
          <td class="small">
            <nk-collateral-items
              [items]="comp.company_collateral.collateral_items ?? []"
              [printVersion]="printVersion()">
            </nk-collateral-items>
          </td>
          <td class="small">
            @if (comp.company_collateral_creditor.company_uuid) {
              <span style="line-height: 1">
                <a [routerLink]="['/company', comp.company_collateral_creditor.company_uuid]">{{
                  comp.company_collateral_creditor.creditor_name | prettyCompanyName
                }}</a>
              </span>
            } @else {
              <span>
                {{ comp.company_collateral_creditor.creditor_name }}
              </span>
            }
          </td>
          <td class="small text-nowrap text-end" [class.text-muted]="comp.company_collateral.deletion_flag">
            {{ comp.company_collateral.amount | thousandSeparated }}
            @if (comp.company_collateral.deletion_flag) {
              <span>({{ 'company_collateral.deleted_flag' | translate }})</span>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
  @if (printVersion() && collateralComposite.count > printLimit) {
    <div class="alert alert-info mt-2">
      <h6 class="mb-0">
        {{ 'common.print_limit_exceeded' | translate: { limit: printLimit, totalCount: collateralComposite.count } }}
      </h6>
    </div>
  }
  @if (!printVersion()) {
    <div class="row ard-list-pagination mt-2">
      <div class="col-4 text-muted align-items-center">
        <span class="text-muted">
          {{ 'common.pagination.total_count' | translate: { totalCount: collateralComposite.count } }}
        </span>
      </div>
      <div class="col-8 d-flex justify-content-end">
        @if (collateralComposite.elements.length < collateralComposite.count) {
          <nk-pagination
            [currentPage]="currentPage()"
            [totalItems]="collateralComposite.count"
            [itemsPerPage]="limit"
            (changePage)="goToPage($event)">
          </nk-pagination>
        }
      </div>
    </div>
  }
}
